export const FETCH_STICK_PRICE = 'FETCH_STICK_PRICE';
export const FETCH_STICK_PRICE_SUCCEED = 'FETCH_STICK_PRICE_SUCCEED';
export const FETCH_STICK_PRICE_FAILED = 'FETCH_STICK_PRICE_FAILED';

export const FETCH_LATEST_PRICE = 'FETCH_LATEST_PRICE';
export const FETCH_LATEST_PRICE_SUCCEED = 'FETCH_LATEST_PRICE_SUCCEED';
export const FETCH_LATEST_PRICE_FAILED = 'FETCH_LATEST_PRICE_FAILED';

export const FETCH_PRICE_24H = 'FETCH_PRICE_24H';
export const FETCH_PRICE_24H_SUCCEED = 'FETCH_PRICE_24H_SUCCEED';
export const FETCH_PRICE_24H_FAILED = 'FETCH_PRICE_24H_FAILED';

export const FETCH_ALL_LATEST_PRICE = 'FETCH_ALL_LATEST_PRICE';
export const FETCH_ALL_LATEST_PRICE_SUCCEED = 'FETCH_ALL_LATEST_PRICE_SUCCEED';
export const FETCH_ALL_LATEST_PRICE_FAILED = 'FETCH_ALL_LATEST_PRICE_FAILED';

export const FETCH_PRICE_MARKET_24H = 'FETCH_PRICE_MARKET_24H';
export const FETCH_PRICE_MARKET_24H_SUCCEED = 'FETCH_PRICE_MARKET_24H_SUCCEED';
export const FETCH_PRICE_MARKET_24H_FAILED = 'FETCH_PRICE_MARKET_24H_FAILED';
